
const newModel = () => {
    return {
        vanDongVienId: null,
        ten: null,
        diaChi: null,
        sdt: null,
        ghiChu: null,
        stt: null,
        bomonThidauInfo: [],
        listBomonThidau: [],
        enabled: null,
        iocId: null,
        iocEnabled: null,
        iocDateUpdated: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        vanDongVienId: null,
        ten: null,
        diaChi: null,
        sdt: null,
        ghiChu: null,
        stt: "0",
        bomonThidauInfo: [],
        listBomonThidau: [],
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        vanDongVienId: item.vanDongVienId,
        ten: item.ten,
        diaChi: item.diaChi,
        sdt: item.sdt,
        ghiChu: item.ghiChu,
        stt: item.stt,
        bomonThidauInfo: item.bomonThidauInfo,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        vanDongVienId: item.vanDongVienId,
        ten: item.ten,
        diaChi: item.diaChi,
        sdt: item.sdt,
        ghiChu: item.ghiChu,
        stt: item.stt,
        bomonThidauInfo: item.bomonThidauInfo,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const errors = () => {
    return {
        vanDongVienId: null,
        ten: null,
        diaChi: null,
        sdt: null,
        ghiChu: null,
        stt: null,
        bomonThidauInfo: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ten: null,
        enabled: null,
    }
}

export const vanDongVienTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


